export default {
  title: 'Lisää kortti',
  buttons: {
    save: 'Tallenna',
  },
  feedback: {
    success: 'Kortti tallennettu onnistuneesti',
  },
};
